import PropTypes from 'prop-types';

import PreviewableNames from 'components/atoms/PreviewableNames';

// The models a part fits, as names that open their picture on click - see
// components/atoms/PreviewableNames for why the pictures are no longer in the
// row itself.
//
// Model names are free text - there is no capacity column on models - so the
// engine size gets typed into the name itself, e.g. "BAYON 2022 (1400)". Strip
// that trailing parenthesised number for display only; the underlying name is
// untouched, so filtering and search still match on the full string.
const stripCapacity = (name) => name?.replace(/\s*\(\d+\)\s*$/, '') || name;

/* Three names is about what one line of the column holds. Past that the list
   was setting the height of the row on its own - a part fitting 25 models ran
   to 401px - so the rest are folded behind a count and come back on a click. */
const COLLAPSE_AFTER = 3;

const ModelImages = ({ models }) => (
  <PreviewableNames
    collapseAfter={COLLAPSE_AFTER}
    items={(models || []).map(({ name, image_url: imageUrl }) => ({
      // Keyed on the full name, so two models that differ only by capacity stay
      // distinct after stripping it for display.
      key: name,
      name: stripCapacity(name),
      imageUrl,
    }))}
  />
);

ModelImages.propTypes = {
  models: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      image_url: PropTypes.string,
    }),
  ),
};

export default ModelImages;
